import { useTranslation } from 'react-i18next';

interface ErrorProps {
  message?: string;
}

const Error = ({ message }: ErrorProps) => {
  const { t } = useTranslation('common');

  return (
    <div
      role="alert"
      className="my-2 rounded-sm border border-red-200 bg-red-50 px-4 py-3 text-red-800"
    >
      <p>{message || t('unknown-error')}</p>
    </div>
  );
};

export default Error;
